// extracted by mini-css-extract-plugin
module.exports = {"CoreButton":"Button_CoreButton__Mlukl","square":"Button_square__uu3M0","inverse":"Button_inverse__QjAWR","large":"Button_large__M4OcG","outline":"Button_outline__3TWhH"};